<template>
  <div class="shop-manual">
    <h2 class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">
      คู่มือการเชื่อมต่อ Shopee
    </h2>
    <v-divider class="tw-mt-8"></v-divider>

    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีการดู Shop ID
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีการสมัคร API และเชื่อมต่อร้านค้ากับ API App
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีการดูค่า Live Partner ID และ Live Key
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีการใส่ Call Back URL
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'ShopChannelManualShopee',
}
</script>

<style lang="scss" scoped>
.shop-manual {
  .v-expansion-panel::before {
    box-shadow: none !important;
  }

  .v-expansion-panel-header {
    padding-left: 0;
  }
}
</style>